import React from 'react'
import {Spin, message, Button, Popconfirm} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@components/Lang/Lang";
import {symbolMoneyUtil,isEmptyObject} from '@utils/utils';
import ConfirmPayment from "./ConfirmPayment";
import PropTypes from 'prop-types';
import ModalConfirmPaymentAction from "./ModalConfirmPayment.action";
import ModalCancelProductAction from "../ModalCancelProduct/ModalCancelProduct.action";
/**
 * 确认付款 组件
 *
 * @author FJJ
 * @version 1.0
 *
 * History:
 * Date      Version Remarks
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ModalConfirmPayment extends React.Component {
    static propTypes = {
        item:  PropTypes.object.isRequired, //  当前操作对象
    }
    static defaultProps = {
     item:{}
    };
    constructor(props) {
        super(props)
        this.state = {
            showDetails: false,
            loading: false,
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    handleShowDetails(flag=false){
        this.setState({
            showDetails:flag,
        })
        if(flag){
            // this.getDeliveryListInfo()
        }
    }
    /*
    * 处理提交
    * @params handleCancel ture:直接取消(全选时),false：进入下一步
    * */
    handleOKPayment(){
         if(this.onRefConfirmPaymentChild){
            const values = this.onRefConfirmPaymentChild.getValues();
             if(!isEmptyObject(values)){
                 const { item,} = this.props;
                 const postData = {...values,
                     isAllCancel: 0,// 是否整单取消 1:整单取消,0非整单取消
                     poId:item.poId,
                 }
                 const sUrl = "/service/mg/sale/chinaOrder/bankCard/confirm-po";
                 this.loading(true);
                 ModalCancelProductAction.post(postData,sUrl).then((res={}) => {
                     this.loading(false)
                     const data = res.data;
                     if (data.success && data.valid) {
                         message.success(Lang({id:"QueRenDingDanChengGong",default:"确认订单成功"}));
                         if(this.props.refreshPage)this.props.refreshPage();
                     } else if(data.message) {
                         message.info(data.message);
                     }
                 }).catch(err=>{
                     this.loading(false)
                 })
             }
         }
    }
    onRefConfirmPayment = (ref) =>this.onRefConfirmPaymentChild = ref;
    render() {
        const { item,} = this.props;
        const {loading, showDetails, checkedObj,selectOrder, } = this.state;
        return (<>
                {<AuthBtn icon={"ri-check-double-line"}
                          tips = {Lang({id:"QueDingDingDan",default:"确定订单"})}
                          onClick={()=>this.handleShowDetails(true)}
                    />}
                {/* 确认付款信息 弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"QueRenFuKuanXinXi",default:"确认付款信息"})}
                                        open={showDetails}
                                        width={750}
                                        onCancel={()=>this.handleShowDetails()}
                                        footer={[
                                           <Button onClick={() => this.handleShowDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                            <Popconfirm
                                                title={Lang({id: "SuoXuanXinXiShiFouYiJingYuKeHuQueRenGuo",default: "所选信息是否已经与客户确认过？"})}
                                                onConfirm={()=>this.handleOKPayment()}
                                                // onCancel={()=>this.handleShowDetails(false)}
                                                okText={Lang({id:'queren',default:'确认'})}
                                                cancelText={Lang({id:'QuXiao',default:'取消'})}>
                                                <Button type="primary">{Lang({id: "QueDing",default: "确定"})}</Button>
                                            </Popconfirm>

                                       ]}>
                    <Spin spinning={loading}>
                        <ConfirmPayment id={item.poId}
                                        currencySymbol={item.currencySymbol}
                                        orderNumber={item.poCode}
                                        iTotal={item.totalPrice}
                                        onRef={this.onRefConfirmPayment} />
                    </Spin>
                </EssaModal>}

            </>
        )
    }
}